module.exports = __webpack_public_path__ + "img/img2.6f7e8250.png";